import React from "react";
import clsx from "clsx";

import Pagination from "./Pagination";

const Footer = ({
  filteredRows,
  paginationState,
  onPaginationChange,
  noAction,
}) => {
  const getStaringCount = (isEndingPoint = false) => {
    const { pageSize, pageNo } = paginationState;
    const _pageSize = parseInt(pageSize);
    const _pageNo = parseInt(pageNo);

    let startingPoint = _pageSize * (_pageNo - 1);

    if (isEndingPoint) startingPoint += _pageSize;
    else if (_pageNo > 1) startingPoint += 1;

    if (startingPoint > filteredRows.count) {
      startingPoint = filteredRows.count;
    }

    if (!filteredRows.count) return 0;

    return startingPoint || 1;
  };

  return (
    <div
      className={clsx("datatable_footer", {
        "no-action": noAction,
      })}
    >
      <div className="datatable_pageinfo">
        <p>{`Showing ${getStaringCount()} to ${getStaringCount(true)} of ${
          filteredRows.count
        } entries`}</p>
      </div>
      <Pagination
        {...paginationState}
        total={filteredRows.count}
        onChange={onPaginationChange}
      />
    </div>
  );
};

export default Footer;
